
import Navbar from '../ShareComponent/Navbar'
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../ShareComponent/Footer'
import '../ShareComponent/Navbar.css'
import './MainLayout.css'
import '../Pages/Common/common.css'

const MainLayout = ({children}) => {
   const navigate = useNavigate();

   useEffect(() => {
     const token = sessionStorage.getItem('token');
     if (!token) {
       navigate('/admin-login');
     }
   }, [navigate]);
   
  return (
   <div className='main-layout'>
     <div className='sidebar-container'>
       <Navbar />
     </div>
     <div className='main-content-container'>
       <main className='main-content'>
         {children}
       </main>
     </div>
   </div>
  )
}

export default MainLayout